
import { Base } from '../base-component';

import './breadcrumbs.component.scss';

export class Breadcrumbs extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/breadcrumbs/breadcrumbs.component.ts